import React from "react";
import axios from "axios";
import ApiComponent from "./ApiComponent";

class BannerApiComponent extends ApiComponent
{
    show(banner_id, success, failed)
    {
        let backendBaseURL = process.env.REACT_APP_API_BASE_URL;
        axios.get( backendBaseURL + "v1/banner/" + banner_id, {})
            .then(res => {
                if(res.data.success) success(res.data.data)
                else failed(res.data.message)
            })
            .catch(ex => {
                console.error(ex.message)
            })
    }

    index(banner_category_id, success, failed)
    {
        let apiURL = process.env.REACT_APP_API_BASE_URL;
        axios.get( apiURL + "v1/banner-category-banner?banner_category_id=" + banner_category_id, {})
            .then(res => {
                if(res.data.success) success(res.data.data)
                else failed(res.data.message)
            })
            .catch(ex => {
                console.error(ex.message)
            }) 
    }

    render() {
        return (
            <div />
        );
    }
}

export default BannerApiComponent;
